<!-- Container-fluid starts-->
<div class="container-fluid">   

  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="card">        
        <div class="card-body">

          <!-- START filter parameter -->
          <div class="row">  
              <div class="col-lg-2 col-md-2 col-12 form-group">              
                <label class="control-label font-danger" *ngIf="filterview.advertiserOfferIds==true">Advertiser offer Id:&nbsp;<i class="fa fa-filter"></i></label>              
                <label class="control-label" *ngIf="filterview.advertiserOfferIds==false">Advertiser offer Id</label>              
                <input type="text" class="form-control" placeholder="-- offer id --" [(ngModel)]='selectedAdvertiserOfferId' (input)="onAdverOfferId($event)">
              </div> 
        
              <div class="col-lg-2 col-md-2 col-2 form-group">
                <label class="form-label font-danger" *ngIf="filterview.offerCategories==true">Type:&nbsp;<i class="fa fa-filter"></i></label>
                <label class="form-label" *ngIf="filterview.offerCategories==false">Type</label>
                <ng-multiselect-dropdown
                [placeholder]="'-- type --'"
                [settings]="dropdownSettingsCategories"
                [data]="dropdownListCategories"
                [(ngModel)]="selectedItemsCategories"
                (onSelect)="onItemSelectType($event)"
                (onDeSelect)="onItemDeSelectType($event)"
                >
                </ng-multiselect-dropdown>
              </div>
        
              <div class="col-lg-2 col-md-2 col-2 form-group">
                <label class="form-label font-danger" *ngIf="filterview.offerDevices==true">Device:&nbsp;<i class="fa fa-filter"></i></label>
                <label class="form-label" *ngIf="filterview.offerDevices==false">Device</label>
                <ng-multiselect-dropdown
                [placeholder]="'-- device --'"
                [settings]="dropdownSettingsDevice"
                [data]="dropdownListDevice"
                [(ngModel)]="selectedItemsDevice"
                (onSelect)="onItemSelectDevice($event)"
                (onDeSelect)="onItemDeSelectDevice($event)"
                (onSelectAll)="onSelectAllDevice($event)"
                >
                </ng-multiselect-dropdown>
              </div>
        
              <div class="col-lg-2 col-md-2 col-2 form-group">
                <label class="form-label font-danger" *ngIf="filterview.offerAdvertisers==true">Advertiser:&nbsp;<i class="fa fa-filter"></i></label>
                <label class="form-label" *ngIf="filterview.offerAdvertisers==false">Advertiser</label>
                <ng-multiselect-dropdown
                [placeholder]="'-- advertiser --'"
                [settings]="dropdownSettingsAdvertiser"
                [data]="dropdownListAdvertiser"
                [(ngModel)]="selectedItemsAdvertiser"
                (onSelect)="onItemSelectAdvertiser($event)"
                (onDeSelect)="onItemDeSelectAdvertiser($event)"
                (onSelectAll)="onSelectAllAdvertiser($event)"
                >
                </ng-multiselect-dropdown>
              </div>
                    
              <div class="col-lg-2 col-md-2 col-2 ">
                <label class="form-label font-danger" *ngIf="filterview.offerCountries==true">Country:&nbsp;<i class="fa fa-filter"></i></label>
                <label class="form-label" *ngIf="filterview.offerCountries==false">Country</label>
                <ng-multiselect-dropdown
                name="country"
                [placeholder]="'-- country --'"
                [settings]="dropdownSettingsCountry"
                [data]="countries"
                [(ngModel)]="selectedItemsCountry"
                (onSelect)="onItemSelectCountry($event)"
                (onDeSelect)="onItemDeSelectCountry($event)"
                (onSelectAll)="onSelectAllCountry($event)"
                >
                </ng-multiselect-dropdown>
                <!-- <button class="btn btn-pill btn-sm btn-info" type="button" ngbTooltip="clear filter" (click)="onClear()" name="btnClear">
                  Clear</button> -->
              </div>
        
              <div class="col-lg-2 col-md-2 col-2 form-group">
                <!-- <button class="btn btn-pill btn-sm {{btnColor}}" type="button" ngbTooltip="apply filter" (click)="onFilter()" name="btnFilter">
                {{btnName}}</button>
                <p></p> -->
                
                <button class="btn btn-pill btn-xs btn-danger" type="button" ngbTooltip="clear filter" (click)="onClear()" name="btnClear">
                  Clear all</button>
              </div>
            
          </div> 
          <!-- END filter parameter -->
          
          <!-- START table -->
          <div class="custom-datatable">
            <ngx-datatable
            class="bootstrap"
            [rows]="offersData"
            [columnMode]="ColumnMode.flex"
            [loadingIndicator]="loading"
            [externalPaging]="true"
            [count]="page.totalElements"
            [offset]="page.pageNumber"
            [limit]="page.size"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            (sort)="sort($event)"
            (page)="setPage($event)"
            >

            <ngx-datatable-column name="advertiserOfferId" [flexGrow]="1" >
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Id</span>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.advertiserOfferId }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="offerName" [flexGrow]="2">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Offer</span>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                <i class="flag-icon flag-icon-{{row.country.alpha2Code | lowercase}}" ></i>&nbsp;
                <a href="adm/offers/{{ row.offerId }}">{{ row.offerName }}</a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="advertiser" [flexGrow]="1" prop="advertiser.name">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Advertiser</span>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.advertiser.name }}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="payout" [flexGrow]="1">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Payout</span>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.payout | currency:"USD":"symbol":"1.1-3"}}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="conversions" [canAutoResize]="true" [flexGrow]="1" [sortable]="false">
              <ng-template let-column="column"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" ></span>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                <small>Global Conversions: {{ row.conversionsGlobal}}<br>Global Clicks: {{ row.clicksGlobal }}</small>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="conversions3last" [flexGrow]="1" [sortable]="false">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()"></span>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                <small>
                  <!-- TST: {{row.capDetails.currentValue}} / {{row.capDetails.setValue}}<br> -->
                  <div *ngIf="row.capDetails.setValue == 0; else elseBlock">
                    CAP: <span style="color:rgb(0, 0, 255);">Off</span><br>
                  </div>
                  <ng-template #elseBlock>
                    <div *ngIf="(row.capDetails.setValue - row.capDetails.currentValue) != 0; else elseBlock1">
                      CAP: <span style="color:rgb(16, 197, 10);">{{row.capDetails.setValue - row.capDetails.currentValue}}</span><br>
                    </div>
                    <ng-template #elseBlock1>
                      CAP: <span style="color:red;">exided</span><br>
                    </ng-template>
                  </ng-template>
                  CR Global:  {{ row.crGlobal | percent}}<br>
                  EPC Global: {{ row.epcGlobal | currency:'CAD':'symbol-narrow':'1.4-4'}}<br>
                  EPC short:  {{ row.epcInDays | currency:'CAD':'symbol-narrow':'1.4-4'}}<br>
                </small>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="createdAtUtc" [flexGrow]="1">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Live since</span>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.createdAtUtc | date:'d/M/yyyy'}}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Status" [flexGrow]="1" prop="status.globalStatus">
              <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                <span class="myHeader txt-primary" (click)="sort()">Status</span>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div *ngIf="row.status.globalStatus=='Active'">
                  <button class="btn btn-pill btn-xs btn-success" type="button" placement="top" name="btnStatus"  (click)="onStatus(row)">
                    <i class="fa fa-exclamation-triangle" *ngIf="row.status.publisherStatus.length>0" ngbTooltip="some publishers have disabled the offer">&nbsp;</i>{{ row.status.globalStatus }}</button>
                </div>
                <div *ngIf="row.status.globalStatus=='Disabled'">
                  <button class="btn btn-pill btn-xs btn-danger" type="button" placement="top" name="btnStatus" (click)="onStatus(row)">
                    {{ row.status.globalStatus }}</button>
                </div>
                <div *ngIf="row.status.globalStatus=='Expired'">
                    {{ row.status.globalStatus }}
                </div>
              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>
          </div>
          <!-- END table -->

        </div>
      </div>
    </div>
  </div>

</div>
<!-- Container-fluid Ends-->
